import styled from "@emotion/styled";
import { at } from "../../styles/utils";
import {
  breakpoints,
  fonts,
  side_content_width,
  spacing,
} from "../../styles/vars";

export const ProjectDescriptionWrapper = styled.div`
  padding: ${spacing.mobile};
  background: rgba(0, 0, 0, 0.5);
  .label {
    display: inline;
    &:after {
      content: ":";
      margin-right: 5px;
    }
  }
  .value {
    display: inline;
    font-family: ${fonts.bold};
    line-height: 1.8em;
  }

  ul {
    display: inherit;
    list-style: none;
    padding: 0;
    margin: 10px 0px;
    li {
      display: inline;
      &:after {
        content: ", ";
      }
      &:last-child:after {
        content: ".";
      }
    }
  }

  .unit {
    font-size: 0.8em;
    margin-left: 5px;
  }

  ${at(breakpoints.laptop)} {
    position: relative;
    width: ${side_content_width.laptop};
    padding: 1.5em ${spacing.mobile} 0;
    height: ${({ opened }) => (opened ? "0px" : "auto")};
    .value {
      margin-top: 0.5em;
    }
  }

  ${at(breakpoints.desktop)} {
    width: ${side_content_width.desktop};
    padding: 0 ${spacing.desktop};
    .value {
      font-size: 1.1em;
    }
  }
`;

export const ResourceDetailsBlock = styled.div`
  margin: 0 0 1em;
  ${at(breakpoints.laptop)} {
    margin: 0 0 0.5em;
  }
`;
